<template>
    <div class="container">
        <!--form-->
        <el-form :inline="true" label-position="left" label-width="80px" :model="queryForm" ref="queryForm">
            <el-form-item label="状态" prop="status">
                <el-select v-model="queryForm.status" placeholder="请选择状态">
                    <el-option label="正常" value="1"></el-option>
                    <el-option label="禁用" value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="用户信息" prop="general">
                <el-input v-model="queryForm.general" placeholder="用户名／手机号／邮箱"></el-input>
            </el-form-item>
            <el-form-item label="创建时间" prop="created_at_start">
                <el-col :span="11">
                    <el-date-picker type="date" placeholder="选择日期" v-model="queryForm.created_at_start" style="width: 100%;"></el-date-picker>
                </el-col>
                <el-col class="t-c" :span="2">-</el-col>
                <el-col :span="11">
                    <el-date-picker type="date" placeholder="选择日期" v-model="queryForm.created_at_end" style="width: 100%;"></el-date-picker>
                </el-col>
            </el-form-item>
            <el-form-item label="修改时间" prop="last_modify_time_start">
                <el-col :span="11">
                    <el-date-picker type="date" placeholder="选择日期" v-model="queryForm.last_modify_time_start" style="width: 100%;"></el-date-picker>
                </el-col>
                <el-col class="t-c" :span="2">-</el-col>
                <el-col :span="11">
                    <el-date-picker type="date" placeholder="选择日期" v-model="queryForm.last_modify_time_end" style="width: 100%;"></el-date-picker>
                </el-col>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="fetchData">查询</el-button>
                <el-button @click="resetForm('queryForm')">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="line"></div>
        <el-row class="pb20">
            <el-button type="primary" v-for="o in operation" v-if="o.name == `user/add`" :key="o.rule_id" @click="addUser()">新增</el-button>
        </el-row>
        <!--table-->
        <el-table
                v-loading="loading"
                :data="tableData"
                border
                style="width: 100%">
            <el-table-column
                    fixed
                    prop="id"
                    label="id"
                    width="80">
            </el-table-column>
            <el-table-column
                    prop="username"
                    label="用户名"
                    :show-overflow-tooltip="true"
                    width="120">
            </el-table-column>
            <el-table-column
                    prop="real_name"
                    label="姓名"
                    :show-overflow-tooltip="true"
                    width="100">
            </el-table-column>
            <el-table-column
                    prop="email"
                    label="邮箱"
                    width="220">
            </el-table-column>
            <el-table-column
                    prop="mobile"
                    label="手机号"
                    width="130">
            </el-table-column>
            <el-table-column
                    prop="authGroup"
                    label="权限组"
                    :show-overflow-tooltip="true"
                    width="130">
            </el-table-column>
            <el-table-column
                    prop="created_at"
                    label="创建时间"
                    width="180">
            </el-table-column>
            <el-table-column
                    prop="statusText"
                    label="状态"
                    width="70">
            </el-table-column>
            <el-table-column
                    prop="owner"
                    label="最后更新者"
                    width="130">
            </el-table-column>
            <el-table-column
                    prop="updated_at"
                    label="最后更新时间"
                    :show-overflow-tooltip="true"
                    width="">
            </el-table-column>
            <el-table-column
                    fixed="right"
                    label="操作"
                    width="220">
                <template slot-scope="scope">
                    <el-button
                            @click.native.prevent="relatedGroup(scope.row)"
                            type="text"
                            size="small"
                            v-for="o in operation" v-if="o.name == `user/relateAuthGroup`" :key="o.rule_id">
                        关联组
                    </el-button>
                    <el-button
                            @click.native.prevent="editUser(scope.row)"
                            type="text"
                            size="small"
                            v-for="o in operation" v-if="o.name == `user/edit`" :key="o.rule_id">
                        编辑
                    </el-button>
                    <el-button
                            @click.native.prevent="forbidUse(scope.row)"
                            type="text"
                            size="small"
                            v-for="o in operation" v-if="o.name == `user/updateStatus`" :key="o.rule_id">
                        {{scope.row.status==1?'禁用':'解禁'}}
                    </el-button>
                    <el-button
                            @click.native.prevent="resetPassword(scope.row)"
                            type="text"
                            size="small"
                            v-for="o in operation" v-if="o.name == `user/resetPassword`" :key="o.rule_id">
                        重置密码
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="queryForm.pageNo"
                :page-sizes="[2, 4, 8, 10]"
                :page-size="queryForm.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="total">
        </el-pagination>
    </div>
</template>

<script>
    import moment from 'moment';
    export default {
        data() {
            return {
                queryForm: {
                    status: '',
                    general: '',
                    authGroup:'',
                    created_at_start: '',
                    created_at_end: '',
                    last_modify_time_start: '',
                    last_modify_time_end: '',
                    pageSize: 10,
                    pageNo: 1
                },
                tableData: [],
                loading: true,
                total: 0
            }
        },
        computed: {
            operation: function(){
                return this.$store.getters.operation
            }
        },
        created() {
            //初始化获取全部数据
            this.fetchData();
        },
        methods: {
            fetchData() {
                if(this.queryForm.created_at_start) this.queryForm.created_at_start = moment(this.queryForm.created_at_start).format('YYYY-MM-DD');
                if(this.queryForm.created_at_end) this.queryForm.created_at_end = moment(this.queryForm.created_at_end).format('YYYY-MM-DD');
                if(this.queryForm.last_modify_time_start) this.queryForm.last_modify_time_start = moment(this.queryForm.last_modify_time_start).format('YYYY-MM-DD');
                if(this.queryForm.last_modify_time_end) this.queryForm.last_modify_time_end = moment(this.queryForm.last_modify_time_end).format('YYYY-MM-DD');

                this.$api.post(this.$apiUrl.userList,{...this.queryForm},(res)=>{
                    this.loading = false;
                    this.total = res.data.total || 0;
                    if(res.data && res.data.user.length>0){
                        for(let v of res.data.user){
                            if(v.status == 1){
                                v.statusText = '正常';
                            }else{
                                v.statusText = '禁用';
                            }
                        }
                        this.tableData = res.data.user;
                    }else{
                        this.tableData = [];
                    }
                },(res)=>{
                    this.tableData = [];
                })
            },
            handleSizeChange(val) {
                this.queryForm.pageSize = val;
                this.fetchData();
            },
            handleCurrentChange(val) {
                this.queryForm.pageNo = val;
                this.fetchData();
            },
            //禁用
            forbidUse(item) {
                var params = {
                    user_id: item.id,
                    owner: this.$store.getters.username
                }
                this.$confirm('确认改变状态吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$api.post(this.$apiUrl.updateStatus,params,(res)=>{
                        this.fetchData();
                    })
                }).catch(() => {

                });
            },
            //重置密码
            resetPassword(item) {
                var params = {
                    user_id: item.id,
                    owner: this.$store.getters.username
                }
                this.$confirm('确认重置密码吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$api.post(this.$apiUrl.resetPassword,params,(res)=>{
                        this.$message.success('重置密码成功');
                        this.fetchData();
                    })
                }).catch(() => {

                });
            },
            addUser() {
                this.$router.push({ path: `/user/add/${this.$route.params.ruleId}`})
            },
            //编辑用户
            editUser(item) {
                this.$router.push({ path: `/user/edit/${this.$route.params.ruleId}/${item.id}`})
            },
            //关联组
            relatedGroup(item) {
                this.$router.push({ path: `/user/relatedGroup/${this.$route.params.ruleId}/${item.id}`})
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            }
        }
    }
</script>


// WEBPACK FOOTER //
// list.vue?34ca78ca